import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@prismicio/next/dist/PrismicNextImage.cjs");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@prismicio/next/dist/PrismicPreviewClient.cjs");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPage"] */ "/opt/atlassian/pipelines/agent/build/src/components/blog/BlogPage.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/hooks/useIsMobile.ts");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/hooks/usePerformance.ts");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/hooks/useScrollLock.ts");
